import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_351_4)">
        <path
          fill="#3F434A"
          d="M16 8.347A1.88 1.88 0 0014.133 6.5a1.87 1.87 0 00-1.56.824.25.25 0 01-.32.084L6.228 4.375a.25.25 0 01-.125-.3A3.134 3.134 0 003.075 0a3.125 3.125 0 00-.76 6.144c.11.03.185.128.185.24v3.97c0 .112-.075.209-.181.24a2.502 2.502 0 00.69 4.906A2.5 2.5 0 005.5 13v-.022c0-.095.054-.183.138-.225l6.657-3.351a.25.25 0 01.313.075A1.874 1.874 0 0016 8.347zm-4.416.29l-6.156 3.1a.25.25 0 01-.323-.088 2.505 2.505 0 00-1.42-1.055.252.252 0 01-.185-.24V6.441a.25.25 0 01.203-.245 3.118 3.118 0 001.692-.923.25.25 0 01.294-.05l5.895 2.968a.25.25 0 010 .446z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_351_4">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
